<script setup lang="ts">
import MenuLink from '@layout/nav-v2/desktop/components/MenuLink.vue';
import { URL_OFFER_CREATE, URL_USER_ORGANIZATION_TEAM } from '@tools/routes/routes';
import { storeToRefs } from 'pinia';
import { useNavbarStore } from '@stores/layout/useNavbarStore';
import IconUserPlus from '@icons/ph_users-plus.svg';
import IconPlus from '@icons/ph_plus.svg';
import Icon from '@components/Icon.vue';
import { trans } from '@elements/translation.ts';
import DesktopUserMenu from '@layout/nav-v2/desktop/components/menus/DesktopUserMenu.vue';
import type { User } from '@models/groups/app';
import { AccountProfile } from '@enums/accountProfile.ts';
import { useUserProfileStore } from '@stores/useUserProfileStore.ts';
import MenuList from '@layout/nav-v2/desktop/components/MenuList.vue';

const { isExpanded } = storeToRefs(useNavbarStore());

const { user, userProfile } = storeToRefs(useUserProfileStore());
</script>

<template>
  <MenuList>
    <li>
      <MenuLink
        v-if="userProfile === AccountProfile.UNQUALIFIED"
        :link="URL_OFFER_CREATE"
        :is-expanded="isExpanded"
        :class="{ 'overflow-hidden': isExpanded }"
      >
        <template #icon>
          <Icon
            :svg="IconPlus"
            width="24"
            height="24"
            fill="gray-darker"
          />
        </template>

        <template #text>
          {{ trans('user_menu.main.create_offer') }}
        </template>
      </MenuLink>

      <MenuLink
        v-else
        :link="URL_USER_ORGANIZATION_TEAM"
        :is-expanded="isExpanded"
        :class="{ 'overflow-hidden': isExpanded }"
      >
        <template #icon="{ isActive }">
          <Icon
            :svg="IconUserPlus"
            width="24"
            height="24"
            :fill="isActive ? 'black' : 'gray-darker'"
          />
        </template>

        <template #text>
          {{ trans('user_menu.main.add_user') }}
        </template>
      </MenuLink>
    </li>

    <li>
      <DesktopUserMenu
        :is-expanded="isExpanded"
        :user="user as User"
      />
    </li>
  </MenuList>
</template>
